import { getWindowProps } from '@Utils/window';

import type { HeroAndTextView } from '../../common/MultiSectionView.types';
import type { ViewData } from '../../common/multisection.data';
import { layoutHeroAndTextLandscape } from './HeroAndTextLayoutLandscape';
import { layoutHeroAndTextPortrait } from './HeroAndTextLayoutPortrait';

export const layoutHeroAndText = ({
  section,
  viewData,
}: {
  section: HeroAndTextView;
  viewData: ViewData;
}) => {
  if (getLayoutMode() === 'landscape') {
    return layoutHeroAndTextLandscape({
      section,
      viewData,
    });
  }

  return layoutHeroAndTextPortrait({
    section,
    viewData,
  });
};

const getLayoutMode = (): 'landscape' | 'portrait' => {
  const { width, layoutMode } = getWindowProps();

  if (layoutMode === 'landscape' || width >= 1400) {
    return 'landscape';
  }

  return 'portrait';
};

export const getMediaType = (): 'image' | 'video' => 'image'; // TODO implement logic for checking if is video or static image

export const hasImagePart = (section: HeroAndTextView): boolean =>
  Boolean(section.dtoData.heroImageUrl);

export const hasTextPart = (section: HeroAndTextView): boolean =>
  Boolean(section.dtoData.title) || Boolean(section.dtoData.text);
